import React from 'react';
import { Button } from './ui/Button';
import { useCurrency } from '../hooks/useCurrency';
import { trackAddToCart } from '../utils/metaPixel';
const SUPER_PACK = {
  name: 'Super Pack',
  image: 'https://cdn.magicpatterns.com/uploads/4tiSeHjgoH37WjGckaRcoD/Super_Pack.png',
  priceMXN: 7.99,
  priceUSD: 7.99,
  checkoutUrl: 'https://pay.hotmart.com/R104430088E'
};
export function StickyBar() {
  const {
    currency
  } = useCurrency();
  const price = '$7.99 USD';
  const handleClick = () => {
    trackAddToCart('Super Pack', currency === 'MXN' ? SUPER_PACK.priceMXN : SUPER_PACK.priceUSD, currency);
    window.open(SUPER_PACK.checkoutUrl, '_blank');
  };
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a1628]/97 border-t border-[#d4af37]/40 shadow-[0_-4px_20px_rgba(0,0,0,0.5)] safe-bottom" data-id="element-352">
      <div className="max-w-5xl mx-auto flex items-center gap-3 md:gap-4 px-3 md:px-6 py-2.5 md:py-3" data-id="element-353">
        {/* Product thumbnail */}
        <div className="w-11 h-11 md:w-14 md:h-14 rounded-lg overflow-hidden border border-[#d4af37]/30 flex-shrink-0" data-id="element-354">
          <img src={SUPER_PACK.image} alt={SUPER_PACK.name} className="w-full h-full object-cover" loading="eager" data-id="element-355" />
        </div>

        {/* Name + Price */}
        <div className="flex flex-col min-w-0 flex-shrink-0" data-id="element-356">
          <span className="text-white font-bold text-xs md:text-sm leading-tight truncate" data-id="element-357">
            {SUPER_PACK.name}
          </span>
          <span className="text-[#d4af37] font-bold text-sm md:text-base leading-tight" data-id="element-358">
            {price}
          </span>
        </div>

        {/* CTA */}
        <div className="ml-auto flex-shrink-0" data-id="element-359">
          <Button onClick={handleClick} className="py-2 px-3 md:px-5 text-[11px] md:text-sm whitespace-nowrap btn-shimmer" data-id="element-360">
            <span className="hidden md:inline" data-id="element-361">
              Obtener el Super Pack con todo lo que necesito
            </span>
            <span className="md:hidden" data-id="element-362">Obtener Super Pack</span>
          </Button>
        </div>
      </div>
    </div>;
}